import { useStoreSelector } from "./redux/useStoreSelector";
import { useEffect, useState } from "react";
import { useApi } from "./useApi";
import { useFetching } from "./system/useFetching";
import { dispatcher } from "../store";


export function useProfile() {
  const { api, isAuth }             = useApi(),
        { withFetching }            = useFetching(),
        profile                     = useStoreSelector( state => state.user.profile),
        client                      = useStoreSelector( s => s.user.client),
        [lastUpdate, setLastUpdate] = useState(Date.now())

  useEffect(() => {
    if (isAuth && profile && profile.relatedEntityId && !client) {
      withFetching(api.getClientsById({id: profile.relatedEntityId}))
        .then( res => {
          if (res.status === 200) {
            const client = res.body
            dispatcher.user.setClient(client)
          }
        })
    }
    if (isAuth && profile && profile.relatedEntityId && Date.now() - lastUpdate > 300000) { // at least 5 minutes since last update
      setLastUpdate(Date.now())
      withFetching(api.getClientsById({id: profile.relatedEntityId}))
        .then( res => {
          if (res.status === 200) {
            const client = res.body
            dispatcher.user.setClient(client)
          }
        })
    }
  }, [api, isAuth, client, profile, withFetching, lastUpdate]);

  return {profile, client}
}
